import { RestaurantTagList } from "../../Component/RestaurantTag/RestaurantTagList";
import { constants } from "../../Constants/constants";

export const RestaurantCuisineList = ({changeUrlQueryString}) => {
  return (
    <RestaurantTagList resource={constants.PATH.RESTAURANT_TAG.RESTAURANT_CUISINE} resourceName="restaurant_cuisine" changeUrlQueryString={changeUrlQueryString}/>
  )
};